import React from 'react';
// import {isEmpty, get} from 'lodash';
// import {useTranslation} from 'react-i18next';
import {
  ModalContent,
  Col,
  ModalTitle,
  ModalLabel,
  ModalSmallText,
  ListItem,
  ModalFooter,
} from './styled';
import Counter from 'components/acommon/Counter';
import Select from 'components/Select';
import Modal from 'components/Modal';
import Button from 'components/Button';
// import api from 'api';
// import Datepicker from 'components/Datepicker';
// import TimePicker from 'components/TimePicker';

type ModalTypes = {
  reservationId?: string;
  housingId?: string;
  isOpenModalOrderDetails: boolean;
  handleModalOrderDetails: () => void;
  handleModalReceiveTicket: () => void;
};

function ModalOrderDetails({
  // reservationId,
  // housingId,
  isOpenModalOrderDetails,
  handleModalOrderDetails,
  handleModalReceiveTicket,
}: ModalTypes) {
  const [peopleNumber, setPeopleNumber] = React.useState<number>(1);
  // const {t} = useTranslation();
  // const handleDownloadButton = React.useCallback(async () => {
  //   console.log('reservationId', reservationId);
  //   if (!reservationId) {
  //     return;
  //   }

  //   const {data, error} = await api.documents.getContracts(
  //     `housing_sample_id=${housingId}`,
  //   );
  //   const contract = get(data, '0.file');

  //   if (contract) {
  //     window.open(contract, '__blank');
  //   }

  //   if (error) {
  //     console.log('error', error);
  //   }
  // }, [housingId, reservationId]);

  const handleModalOrderDetailsButton = () => {
    handleModalOrderDetails();
    handleModalReceiveTicket();
  };

  const handleOnCloseModal = () => {
    handleModalOrderDetails();
  };

  if (!isOpenModalOrderDetails) {
    return null;
  }

  return (
    <Modal
      open={isOpenModalOrderDetails}
      onClose={handleOnCloseModal}
      closeOnDocumentClick
      closeOnEscape
      withCloseButton
      contentStyle={{padding: '50px', borderRadius: '15px'}}
    >
      <Col>
        <ModalTitle>Ralf will kindly and safely drive you</ModalTitle>
        <ModalSmallText>This deal has to be accepted by the host.</ModalSmallText>
        <ModalContent>
          <Col style={{maxWidth: '370px', width: '100%'}}>
            <ListItem>
              <div className="modalLabel">Date</div>
              <div className="modalValue">May 31, 2021</div>
            </ListItem>
            <ListItem>
              <div className="modalLabel">Time</div>
              <div className="modalValue">
                12:45
                {/* <TimePicker
                  value={{value: '07:30'}}
                /> */}
              </div>
            </ListItem>
            <ListItem>
              <ModalLabel>Number</ModalLabel>
              <div>
                <Counter
                  value={peopleNumber}
                  onDecrement={() => setPeopleNumber(peopleNumber - 1)}
                  onIncrement={() => setPeopleNumber(peopleNumber + 1)}
                />
              </div>
            </ListItem>
          </Col>
          <Col>
            <Col className="modalSelect">
              <ModalLabel>Pick-up place</ModalLabel>
              <Select />
            </Col>
            <Col className="modalSelect">
              <ModalLabel>Drop-off place</ModalLabel>
              <Select />
            </Col>
          </Col>
        </ModalContent>
        <ModalFooter>
          <Button
            label="Request"
            iconRight="shoppingBagIcon"
            onClick={handleModalOrderDetailsButton}
            short
          />
        </ModalFooter>
      </Col>
    </Modal>
  );
}

export default ModalOrderDetails;
